import { isDesktop } from "react-device-detect";
import { DesktopPage } from "./DesktopPage";
import { MobilePage } from "./MobilePage";
import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useConfig } from "../../context/ConfigContext";
import { useNavigate } from "react-router-dom";
import i18n from "../../i18n";

export const WelcomePage = ({ onFinish }) => {
  const { t } = useTranslation("homeModule");
  const { setIsNLUser } = useConfig();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchGeoLocation = () => {
      const queryParams = new URLSearchParams(window.location.search);
      const shopRegion = queryParams.get("shop");

      if (!["de", "nl"].includes(shopRegion)) {
        queryParams.set("shop", "de");
        navigate(`?${queryParams.toString()}`, { replace: true });
        i18n.changeLanguage("de");
      } else {
        setIsNLUser(shopRegion === "nl" ?? false);
        i18n.changeLanguage(shopRegion);
      }
      setIsLoading(false);
    };

    fetchGeoLocation();
  }, []);

  return (
    <>
      {isLoading ? (
        <div className="home-loading-page">
          <CircularProgress
            disableShrink
            color="inherit"
            size={40}
            thickness={4}
          />
          <p className="loading-text">{t("initializing")}...</p>
        </div>
      ) : isDesktop ? (
        <DesktopPage />
      ) : (
        <MobilePage onFinish={onFinish} />
      )}
    </>
  );
};
